// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VisualizationXPathes_VizualuzationXPathes__jSSKy {
  width: 100% !important;
  height: 52vh;
  overflow-x: scroll;
  overflow-y: scroll;
  scroll-behavior: smooth;
}
@media screen and (max-height: 1030px) {
  .VisualizationXPathes_VizualuzationXPathes__jSSKy {
    height: 51vh;
  }
}
.VisualizationXPathes_VizualuzationXPathes__jSSKy::-webkit-scrollbar {
  width: 4px !important;
  height: 4px !important;
}
.VisualizationXPathes_VizualuzationXPathes__jSSKy::-webkit-scrollbar-thumb {
  background-color: #04867a;
  border-radius: 50px;
  width: 2px;
}
.VisualizationXPathes_VizualuzationXPathes__jSSKy::-webkit-scrollbar-track {
  background: #e2e4e7;
}`, "",{"version":3,"sources":["webpack://./src/components/modules/tables/components/DocumentProcessing/TreatmentCDA/VisualizationXPathes/VisualizationXPathes.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,YAAA;EAIA,kBAAA;EACA,kBAAA;EACA,uBAAA;AAFF;AAHE;EAHF;IAII,YAAA;EAMF;AACF;AAFE;EACE,qBAAA;EACA,sBAAA;AAIJ;AADE;EACE,yBAAA;EACA,mBAAA;EACA,UAAA;AAGJ;AAAE;EACE,mBAAA;AAEJ","sourcesContent":[".VizualuzationXPathes {\n  width: 100% !important;\n  height: 52vh;\n  @media screen and (max-height: 1030px) {\n    height: 51vh;\n  }\n  overflow-x: scroll;\n  overflow-y: scroll;\n  scroll-behavior: smooth;\n  &::-webkit-scrollbar {\n    width: 4px !important;\n    height: 4px !important;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #04867a;\n    border-radius: 50px;\n    width: 2px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #e2e4e7;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"VizualuzationXPathes": `VisualizationXPathes_VizualuzationXPathes__jSSKy`
};
export default ___CSS_LOADER_EXPORT___;
